import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { RevisionIssueScanResponse } from '../../../../shared/types/routes/revisions';

//  Function to kick off an issue scan for a given revision.
function scanRevision(revisionLocator: string, params?: { steady?: boolean }) {
  return get<RevisionIssueScanResponse>(`/api/revisions/${nuc(revisionLocator)}/issues`, false, params);
}

/**
 * Mutation which will kick off an issue scan for a given revision.
 * Automatically invalidates the revision query on success to refetch updated data.
 * Shows success/error toasts on completion.
 */
export default function useScanRevision() {
  return useToastedMutation({
    mutationFn: scanRevision,
    successToastMessage: 'Issue scan completed successfully',
    errorToastMessage: 'Failed to scan for issues',
    onSuccess: (_data, revisionLocator) => {
      // Invalidate the revision query to refetch the updated data
      const revisionQueryKey = ['revisions', revisionLocator];
      queryClient.invalidateQueries(revisionQueryKey);
    },
  });
}
